/**
 * Backend nie ma pola kierunku: wynika ono ze znaku kwoty i typu alokacji
 * (HANDOFF §7.8). Front trzyma je jawnie, bo od kierunku zależy cały kształt
 * formularza, a nie tylko ikona przy kwocie.
 */
export enum TransactionDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}
